// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gw-star-rating{display:inline-block;position:relative;white-space:nowrap}.gw-star-rating__inactive{display:flex;gap:var(--spacing-4xs);opacity:.3}.gw-star-rating__active{display:flex;gap:var(--spacing-4xs);overflow:hidden;position:absolute;top:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
